import React, { MouseEventHandler } from "react";
import { IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import NavItemSmallScreen from "./NavItemSmallScreen";
import { NAV_ELEMENTS } from "constant/navigation";
import { NavElement } from "type/navigation/main_navigation.type";
import GroupNavigationMob from "../GroupNavigationMob";

type NavItemProps = {
  navItem: NavElement;
};

type NavMenuSmallScreenProps = {
  showMenu: boolean;
  menuShowClickHandle: MouseEventHandler<HTMLButtonElement>;
  navItemClickHandle: () => void;
};

const NavMenuSmallScreen = ({
  showMenu,
  menuShowClickHandle,
  navItemClickHandle,
}: NavMenuSmallScreenProps) => {
  const NavItem = ({ navItem }: NavItemProps) => (
    <NavItemSmallScreen navItem={navItem} clickHandle={navItemClickHandle} />
  );

  return (
    <Wrapper>
      <HamburgerButton>
        <IconButton aria-label="Open menu" onClick={menuShowClickHandle}>
          <FontAwesomeIcon icon={faBars as any} />
        </IconButton>
      </HamburgerButton>

      {/* Meni koji se pojavljuje ispod logotipa */}
      {showMenu && (
        <Menu>
          <DivMenuItems>
            <NavItem navItem={NAV_ELEMENTS.HOME} />
            <GroupNavigationMob clickHandle={navItemClickHandle} />
            <NavItem navItem={NAV_ELEMENTS.MUZEJ_SAVREMENE_UMETNOSTI} />
            <NavItem navItem={NAV_ELEMENTS.ABOUT} />
            <NavItem navItem={NAV_ELEMENTS.COPYRIGHT} />
            <NavItem navItem={NAV_ELEMENTS.ARTISTS} />
            <NavItem navItem={NAV_ELEMENTS.ART_MOVEMENTS_AND_PHENOMENA} />
          </DivMenuItems>
        </Menu>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div.attrs({ className: "screen-small" })`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;
  z-index: 100;
`;

const HamburgerButton = styled.div`
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 1000;
`;

const Menu = styled.div`
  position: fixed;
  top: 3.5rem;
  left: 0;
  right: 0;
  margin: 0 auto;

  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.05);

  display: flex;
  flex-direction: column;

  z-index: 999;
`;

const DivMenuItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-right: 1rem;
  padding-left: 1rem;
  padding-bottom: 1rem;
`;

export default NavMenuSmallScreen;
